export const getLocationValue = location => {
  if (location) {
    return (
      (location.workspace && location.workspace.id) ||
      (location.room && location.room.id) ||
      (location.building && location.building.id) ||
      (location.site && location.site.id) ||
      (location.site && location.site.country_id) ||
      (location.company && location.company.id) ||
      null
    );
  }

  return 'No Location assigned';
};
